export const ROLE_ADMIN= 'admin';
export const ROLE_CHIEF = 'jefe_de_flota';
export const ROLE_DRIVER = 'default';
